import { useQuery } from '@tanstack/react-query';
import Button from 'components/Button';
import { Link, useSearchParams } from 'react-router-dom';
import HTTPClient from 'services/HTTPClient';
import { EditOutlined } from '@ant-design/icons';

export type Book = {
    id: number
    grade: string
    topic: string
    file: {
        name: string
        url: string
    }
    uploaded_by: {
        id: number
    }
}

type Props = {
    books: Book[]
}

export const useBooks = (by: 'me' | 'org', enabled = true) => {
    return useQuery<Book[]>({
        queryKey: ['books', by],
        enabled,
        queryFn: async () => {
            const url = `/api/books?by=${by}`
            let books = await HTTPClient.get().getJSONResult(url)
            return books
        }
    });
};

export default function BooksList({ books }: Props) {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <div className='w-100'>
            <table className='table w-100'>
                <thead>
                    <tr>
                        <th>Source</th>
                        <th>Grade</th>
                        <th>Topic</th>
                        <th align='center'>Chat with PDF</th>
                        <th align='center'>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {books.map(book => {
                        let item = book;
                        return <tr>
                            <td>
                                <div>
                                    <p>
                                        <Link to={`/knowledge_base/${item.id}?${searchParams}`}>{item.file.name}</Link>
                                    </p>
                                    <div
                                        title={item.file.url}
                                        style={{
                                            maxWidth: "400px",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden"
                                        }}>
                                        {item.file.url}
                                    </div>
                                </div>
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                                {item.grade}
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                                {item.topic}
                            </td>
                            <td align='center'>
                                <Link to={`/document/${book.id}`}>
                                    <Button type='button' variant="is-light" className='mr-3'>Chat with PDF</Button>
                                </Link>
                            </td>
                            <td align='center'>
                                <Link to={`/knowledge_base/${item.id}?${searchParams}`}>
                                    <Button type='button' variant="is-light" className='mr-3'>
                                        <EditOutlined className='mr-2' />
                                        Edit
                                    </Button>
                                </Link>
                            </td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    )
}